<img src="Hospify_bg.svg" alt="" class="bottomCircle">
<img src="Hospify_bg.svg" alt="" class="topCircle">
